import { makeStyles } from '@mui/styles';
import Grid from 'apollo-react/components/Grid';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import TextBoxControl from './TextBox';
import ZoomControl from './Zoom';
import { useSavedSearchSelector } from '../../custom-hooks';
import { editSavedSearch } from '../actions/editor.actions';
import { getSavedSearchProp } from '../selectors/editor.selectors';

const useStyles = makeStyles({
  column: {
    display: 'flex',
    flexDirection: 'row',
    width: 550,
    alignItems: 'center',
    marginTop: 5,
    marginRight: 35,
    '@media (max-width: 480px)': {
      width: '100%',
      paddingRight: 10,
    },
  },
  rowLabel: {
    width: 200,
    paddingTop: 8,
    marginRight: 20,
    alignItems: 'center',
  },
  rowControl: {
    flex: 1,
    alignItems: 'center',
    '& div': {
      margin: 0,
    },
  },
});

const Rights = ({ prop }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const viewRightValue = useSavedSearchSelector(getSavedSearchProp, { prop });

  const handleOnSelect = useCallback(
    (selection) => {
      dispatch(editSavedSearch({ prop, value: selection.RHT_CODE }));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <>
      <Grid item xs={12} lg={5}>
        <div className={classes.column}>
          <TextBoxControl prop={prop} label="View Right" currentValue={viewRightValue} />
          <ZoomControl
            prop={prop}
            isAutoCompleteLoading={false}
            title="All Rights"
            entityName="V_RHT_RIGHT"
            savedSearchName="All Rights"
            handleOnSelect={handleOnSelect}
          />
        </div>
      </Grid>
    </>
  );
};

export default Rights;
